<template>
  <div class="companies">
    <SectionHeader>
      <template v-slot:breadcrumbs>
        <BreadCrumbs :items="[{ text: $t('meta.sensors'), name: 'company_sensors' }, { text: $t('meta.import') }]" />
      </template>
    </SectionHeader>

    <div class="body-content cf">
      <CompanyNav />
      <div class="body">
        <div class="content-wrap">
          <header class="content-header cf">
            <h3>{{ $t('meta.import') }} (.csv)</h3>
          </header>
          <div class="content-body">
            <LoadingSpinner v-if="importing">
              <template #content>
                <div class="alert alert--centered alert-info">
                  <p>{{ $t('meta.importing') }}</p>
                  <p>{{ importedCount }}/{{ importObjects }} {{ $t('meta.sensors') }} {{ $t('meta.imported') }}.</p>
                </div>
              </template>
            </LoadingSpinner>
            <div v-else>
              <vue-csv-import
                v-model="csv"
                url="/import_placeholder"
                headers="true"
                :autoMatchFields="true"
                :map-fields="mapFields"
                :finally="importNow"
              >
                <template slot="error">{{ $t('imports.wrongFileType') }}</template>

                <template slot="thead">
                  <tr>
                    <th>{{ $t('imports.fields') }}</th>
                    <th>{{ $t('imports.columns') }}</th>
                  </tr>
                </template>

                <template slot="next" slot-scope="{ load }">
                  <button @click.prevent="load" class="button button-green button-round button-small">
                    {{ $t('imports.assignNow') }}
                  </button>
                </template>

                <template slot="submit" slot-scope="{ submit }">
                  <button @click.prevent="submit" class="button button-green button-round button-small">
                    {{ $t('imports.importNow') }}
                  </button>
                </template>
              </vue-csv-import>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { VueCsvImport } from 'vue-csv-import'

import BreadCrumbs from '@/components/BreadCrumbs'
import LoadingSpinner from '@/components/LoadingSpinner'
import SectionHeader from '@/components/SectionHeader'
import CompanyNav from '@/components/company_nav'

import containersApi from '@/api/container'
import sensorsApi from '@/api/sensors'
import { mapSettings } from '@/utils/settings'

export default {
  name: 'import_sensor',
  data: () => ({
    searchLoading: false,
    csvLoading: false,
    csv: null,
    importing: false,
    importObjects: 0,
    importedCount: 0,
  }),
  components: {
    BreadCrumbs,
    CompanyNav,
    LoadingSpinner,
    VueCsvImport,
    SectionHeader,
  },
  computed: {
    ...mapSettings(['userLanguage']),
    mapFields() {
      const csvFieldsMap = {
        de: {
          uuid: 'UUID',
          hardware_id: 'Hardware-ID',
          name: 'Name',
          sensor_type: 'Typ',
          container_uuid: 'Behälter-UUID',
        },
        en: {
          uuid: 'UUID',
          hardware_id: 'Hardware ID',
          name: 'Name',
          sensor_type: 'Type',
          container_uuid: 'Container UUID',
        },
      }

      return csvFieldsMap[this.userLanguage]
    },
  },
  methods: {
    importNow() {
      if (this.csv.length === 0) {
        this.$notify({
          group: 'alert',
          type: 'error',
          text: this.$t('imports.noContents'),
        })
      } else {
        const firstSensor = this.csv[0]
        if (firstSensor.hardware_id && firstSensor.sensor_type) {
          this.importing = true
          this.importObjects = this.csv.length
          this.csv.forEach(sensor => {
            if (sensor.uuid) {
              this.updateSensor(sensor)
            } else {
              this.createSensor(sensor)
            }
          })
        } else {
          this.$notify({
            group: 'alert',
            type: 'error',
            text: this.$t('imports.requiredFieldsMissing'),
          })
        }
      }
    },
    async createSensor(sensor) {
      const newSensor = await sensorsApi.create(sensor)
      if (newSensor) {
        this.completeOperation(newSensor, sensor)
      }
    },
    async updateSensor(sensor) {
      const updatedSensor = await sensorsApi.update(sensor.uuid, sensor)
      if (updatedSensor) {
        this.completeOperation(updatedSensor, sensor)
      }
    },
    async redirect() {
      if (this.importObjects === this.importedCount) {
        await this.$router.push(`/company/sensors`)
      }
    },
    async completeOperation(sensorData, csvData) {
      if (sensorData) {
        if (!csvData.container_uuid) {
          this.importedCount++
          this.redirect()
        } else {
          const sensorAssignedToContainer = await containersApi.sensors.assign(csvData.container_uuid, sensorData.uuid)
          if (sensorAssignedToContainer) {
            this.importedCount++
            this.redirect()
          }
        }
      }
    },
  },
}
</script>
